import script from "./FordRiskControlPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FordRiskControlPanel.vue?vue&type=script&setup=true&lang=js"

import "./FordRiskControlPanel.vue?vue&type=style&index=0&id=761b51e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-761b51e4"]])

export default __exports__